<div *ngIf="student.extraInfos" class="d-flex flex-column justify-content-start align-items-start h-100 w-100">

    <div class="bg-grey-lighter-color w-100 mb-3 p-2">
        <span class="fs-5 fw-bolder">Información de interés</span>
    </div>

    <div class="w-100">

        <div class="w-100" *ngFor="let studentExtraInfo of student.extraInfos">

            <div *ngIf="studentExtraInfo.extraInfoName !== 'observaciones'" class="row w-100">

                <div class="col-12 col-lg-2">

                    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
                        <span class="text-primary-color fw-bolder" [appAsterisk]="true">{{ studentExtraInfo.extraInfoDisplayName }}</span>
                        <p-dropdown
                            class="w-100"
                            styleClass="w-100"
                            optionLabel="label"
                            optionValue="value"
                            [options]="yesNoOptions"
                            [(ngModel)]="studentExtraInfo.active"
                            (ngModelChange)="onStudentChange()"/>
                    </div>

                </div>

                <div class="col-12 col-lg-10">

                    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
                        <span class="text-primary-color fw-bolder" [appAsterisk]="true">Observaciones</span>
                        <input type="text" pInputText
                            class="w-100"
                            [disabled]="!studentExtraInfo.active"
                            [(ngModel)]="studentExtraInfo.observations"
                            (ngModelChange)="onStudentChange()"/>
                    </div>

                </div>

            </div>

            <div *ngIf="studentExtraInfo.extraInfoName === 'observaciones'" class="row w-100">

                <div class="col-12">

                    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">

                        <span class="text-primary-color fw-bolder">{{ studentExtraInfo.extraInfoDisplayName }}</span>
                        <textarea
                            class="w-100" styleClass="w-100"
                            pInputTextarea
                            rows="3"
                            [(ngModel)]="studentExtraInfo.observations"
                            (ngModelChange)="onStudentChange()">
                        </textarea>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>
